<template>
  <div class="BlogDetail">
    <app-menu :active.sync="menuOpened" :bottom="true" />
    <top-navbar :menu-opened.sync="menuOpened" />

    <div class="fixed-social-medias">
      <a
        v-for="item in socialNetworks"
        :key="item.icon"
        target="_blank"
        :href="item.href"
      >
        <component :is="item.icon" />
      </a>
    </div>

    <div class="site-section-v post-container">
      <section class="post-content">
        <div
          v-if="post.category !== 1"
          :style="`background-image: url('${post.image}')`"
          class="post-content-banner"
        ></div>
        <div class="video" v-if="!!videoId">
          <iframe
            id="ytplayer"
            type="text/html"
            :src="`https://www.youtube.com/embed/${videoId}`"
            frameborder="0"
          />
        </div>
        <h2 class="text-blue">{{ post.title }}</h2>
        <div class="post-content-info">
          <div class="item">
            <small>por </small><strong> {{ post.author }}</strong>
          </div>
          <div class="item">
            <calendar-icon width="20" /> <span>{{ post.posted_at }}</span>
          </div>
          <!-- <div class="item" v-if="$route.params.type !== 'video'">
            <clock-icon width="20" /> <span>5 minutos</span>
          </div> -->
          <span class="flex-1"></span>
          <div class="item">
            Compartilhe:
            <span class="post-content-social-networks">
              <a
                :href="item.href"
                v-for="item in socialNetworks"
                :key="item.icon"
                target="_blank"
              >
                <component :is="item.icon" />
              </a>
            </span>
          </div>
          <!-- <div class="item">
            <img src="@/assets/img/audima.png" width="600" />
          </div> -->
        </div>

        <hr class="is-large" />
        <div
          class="post-content-categories"
          v-if="$route.params.type !== 'video'"
        >
          <label
            :key="category"
            class="category"
            v-for="category in post.categories"
          >
            {{ category.toUpperCase() }}
          </label>
        </div>

        <article v-html="post.text" class="post-content-text"></article>
      </section>
      <hr />

      <tags :items="post.tags" />

      <hr />
      <logo-card-horizontal theme="blue" />
      <hr />

      <profile-card-horizontal
        :to="{ name: 'page_about' }"
        name="Crivelli Advogados"
        description="Escritório especializado em Direito trabalhista, previdenciário, cível, sindical e direito médico"
      />
      <hr />

      <newsletter theme="orange" />
    </div>
  </div>
</template>

<script>
import AppMenu from "@/components/Menu";
import ArrowHorizontal from "@/components/Svg/ArrowHorizontal";
import CalendarIcon from "@/components/Svg/CalendarIcon";
import HiperlinkIcon from "@/components/Svg/HiperlinkIcon";
import LogoIcon from "@/components/Svg/LogoIcon";
import MessegerIcon from "@/components/Svg/MessegerIcon";
import Newsletter from "@/components/Blog/Newsletter";
import PostCard from "@/components/Blog/PostCard";
import PostLinks from "@/components/Blog/PostLinks";
import SquareFacebookIcon from "@/components/Svg/SquareFacebookIcon";
import SquareLinkedinIcon from "@/components/Svg/SquareLinkedinIcon";
import Tags from "@/components/Blog/Tags";
import TopNavbar from "@/components/Blog/TopNavbar";

import TwitterIcon from "@/components/Svg/TwitterIcon";
import WhatsappIcon from "@/components/Svg/WhatsappIcon";
import ClockIcon from "@/components/Svg/ClockIcon";
import LogoCardHorizontal from "@/components/LogoCardHorizontal";
import ProfileCardHorizontal from "@/components/ProfileCardHorizontal";
import api from "../../services/api";
import { getIdFromURL } from "vue-youtube-embed";

export default {
  components: {
    AppMenu,
    ArrowHorizontal,
    CalendarIcon,
    ClockIcon,
    HiperlinkIcon,
    LogoCardHorizontal,
    LogoIcon,
    MessegerIcon,
    Newsletter,
    PostCard,
    ProfileCardHorizontal,
    PostLinks,
    SquareFacebookIcon,
    SquareLinkedinIcon,
    Tags,
    TopNavbar,
    TwitterIcon,
    WhatsappIcon,
  },

  metaInfo() {
    return {
      title: this.post.title,
      meta: [
        { name: "description", content: this.post.title },
        { name: "og:title", content: this.post.title },
        { name: "og:url", content: location.href}, 
        { name: "og:description", content: this.post.title}, 
        { name: "og:image", content: this.post.image}, 
        { name: "og:type", content: 'article'}, 
      ],
    };
  },
  async created() {
    const { data: post } = await api.get(`posts/${this.$route.params.slug}`);
    if (post.video) {
      this.videoId = getIdFromURL(post.video);
    }

    this.post = post;
  },

  computed: {
    socialNetworks() {
      return [
        {
          href: `https://api.whatsapp.com/send?text=${location.href}&utm_source=whatsapp&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "whatsapp-icon",
        },
        {
          href: `https://www.facebook.com/sharer/sharer.php?u=${location.href}&utm_source=facebook&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "square-facebook-icon",
        },
        {
          href: `https://twitter.com/intent/tweet?url=${location.href}&text=&utm_source=twitter&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "twitter-icon",
        },
        {
          href: `https://www.linkedin.com/shareArticle?mini=true&url=${location.href}&utm_source=linkedin&utm_medium=blog&utm_campaign=compartilhamento`,
          icon: "square-linkedin-icon",
        },
      ];
    },
  },

  // methods: {
  //   async detail(slug) {
  //     this.loading = true;

  //     try {
  //       this.post = await api.get(`posts/${slug}`);
  //     } finally {
  //       this.loading = false;
  //     }
  //   },
  // },

  data() {
    return {
      menuOpened: false,
      post: {},
      videoId: null,
      related_posts: [],
      video: null,
    };
  },
};
</script>
